import {_serializeSingle, _serializeExcept, _serializeExceptList} from './core';
import type {ServerData} from './core';
import type {SerializedWithRaw} from './core';

// User
/** 응답에 실리지 않는 user 필드 — 요청 전용 */
const USER_RESPONSE_OMIT = ["password"] as const;

export function serializeUser(data: ServerData) {
    return _serializeExcept("user", data, USER_RESPONSE_OMIT);
}

export function serializeUserList(data: ServerData) {
    return _serializeExceptList("user", data, USER_RESPONSE_OMIT);
}

// User Token
/** 토큰 발급 응답이 싣지 않는 필드 */
const USER_TOKEN_OMIT = ["createdDate", "updatedDate"] as const;

export function serializeUserToken(data: ServerData) {
    return _serializeExcept("userToken", data, USER_TOKEN_OMIT);
}

// Expansion Token
export function serializeExpansionToken(data: ServerData): SerializedWithRaw<"expansionToken"> | null {
    if (!data) return null;
    return {
        ...data,
        ..._serializeSingle("expansionToken", data),
    };
}
